import React, { useState } from "react";
import Page from "../../../components/Page";
import { Box, Paper, TextField, Typography } from "@mui/material";
import Breadcrumb from "../../../components/breadcrumb/BreadCrumb";
import BasicButton from "../../../components/mui/Button";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomGridToolbar from "../../../components/datagrid/GridToolBar";
import { DataGrid } from "@mui/x-data-grid";
import { PAID_ASSESSMENT_ANALYTICS } from "../../../components/datagrid/CRM/PaidAssessmentTableHead";

const CrmPaidAssessmentAnalytics = () => {
    const [gridSize, setGridSize] = useState(5);

    const dummyDataPaidAssessment = [
        {
            serialNumber: 1,
            ogaName: "Dummy OGA 1",
            totalLeads: 50,
            assessmentConfirmed: 40,
            confirmAdmission: 35,
            pendingResponse: 5,
            callNotAttended: 2,
            notReachable: 3,
            notAttended: 2,
            notNeededAssessment: 8,
            admissionConfirmed: 25,
        },
        {
            serialNumber: 2,
            ogaName: "Dummy OGA 2",
            totalLeads: 60,
            assessmentConfirmed: 50,
            confirmAdmission: 45,
            pendingResponse: 8,
            callNotAttended: 3,
            notReachable: 4,
            notAttended: 1,
            notNeededAssessment: 10,
            admissionConfirmed: 30,
        },
        {
            serialNumber: 3,
            ogaName: "Dummy OGA 3",
            totalLeads: 70,
            assessmentConfirmed: 55,
            confirmAdmission: 50,
            pendingResponse: 10,
            callNotAttended: 1,
            notReachable: 2,
            notAttended: 3,
            notNeededAssessment: 12,
            admissionConfirmed: 35,
        },
        {
            serialNumber: 4,
            ogaName: "Dummy OGA 4",
            totalLeads: 80,
            assessmentConfirmed: 60,
            confirmAdmission: 55,
            pendingResponse: 15,
            callNotAttended: 4,
            notReachable: 1,
            notAttended: 1,
            notNeededAssessment: 15,
            admissionConfirmed: 40,
        },
        {
            serialNumber: 5,
            ogaName: "Dummy OGA 5",
            totalLeads: 90,
            assessmentConfirmed: 70,
            confirmAdmission: 65,
            pendingResponse: 20,
            callNotAttended: 1,
            notReachable: 2,
            notAttended: 4,
            notNeededAssessment: 18,
            admissionConfirmed: 45,
        },
    ];

    return (
        <Page title="My Tasks">
            <Box
                sx={{
                    width: "90%",
                    margin: "0 auto",
                }}
            >
                <Typography variant="h4" sx={{ mb: 1 }}>
                    Paid Assessment Analytics
                </Typography>
                <Breadcrumb sx={{ paddingLeft: 0.3 }} />
                <Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "right",
                        }}
                    >
                        <BasicButton
                            variant="contained"
                            sx={{
                                display: "flex",
                                gap: 1,
                            }}
                        >
                            Unassigned Leads :-0
                        </BasicButton>
                    </Box>
                    <Paper
                        elevation={3}
                        sx={{ borderRadius: 1, width: "100%", mt: 4 }}
                    >
                        <Box
                            sx={{
                                backgroundColor: "grey.200",
                                borderRadius: "8px 8px 0 0",
                                display: "flex",
                                p: 2,
                                gap: 2,
                            }}
                        >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DesktopDatePicker
                                    label="From Date"
                                    inputFormat="DD/MM/YYYY"
                                    // onChange={handleDateDateChange}
                                    renderInput={(params) => (
                                        <TextField
                                            variant="filled"
                                            {...params}
                                        />
                                    )}
                                />
                                <DesktopDatePicker
                                    label="To Date"
                                    inputFormat="DD/MM/YYYY"
                                    // onChange={handleDateDateChange}
                                    renderInput={(params) => (
                                        <TextField
                                            variant="filled"
                                            {...params}
                                        />
                                    )}
                                />
                            </LocalizationProvider>

                            <GlobalSelectField
                                options={{
                                    label: "lead Type",
                                }}
                            />

                            <GlobalSelectField
                                options={{
                                    label: "Campaign",
                                }}
                            />

                            <GlobalSelectField
                                options={{
                                    label: "Source",
                                }}
                            />

                            <GlobalSelectField
                                options={{
                                    label: "Course",
                                }}
                            />
                        </Box>

                        <Box sx={{ width: "100%", padding: 0 }}>
                            <DataGrid
                                rows={dummyDataPaidAssessment}
                                columns={PAID_ASSESSMENT_ANALYTICS}
                                components={{ Toolbar: CustomGridToolbar }}
                                autoHeight
                                sx={{
                                    "& .MuiDataGrid-columnHeaderTitle": {
                                        textOverflow: "clip",
                                        whiteSpace: "break-spaces",
                                        lineHeight: 1,
                                    },
                                }}
                                getRowId={(row) => row.serialNumber}
                                pageSize={gridSize}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                onPageSizeChange={(newGridSize) =>
                                    setGridSize(newGridSize)
                                }
                            />
                        </Box>
                    </Paper>
                </Box>
            </Box>
        </Page>
    );
};

export default CrmPaidAssessmentAnalytics;
